/**
 * @generated SignedSource<<b8a1fd7aca383ad07e55354c277c84ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_transaction" | "CheckoutMobileSummaryNewPane_transaction" | "CheckoutSidebar_transaction" | "CheckoutSteps_transaction">;
  readonly " $fragmentType": "CheckoutLayout_transaction";
};
export type CheckoutLayout_transaction$key = {
  readonly " $data"?: CheckoutLayout_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "8318e974670157dd47b07abace402105";

export default node;
